import React from "react";
import s from "./DisableApiKey.module.scss";
import clsx from "clsx";
import { useForm, SubmitHandler } from "react-hook-form";
import { Button } from "antd";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import useSWRMutation from "swr/mutation";
import {
  parseClientError,
  swrMutationFetcher,
  SwrMutationFetcherArgType,
} from "../../../../../../libs/api/Endpoints";
import { SuccessDataType } from "../../../../../../libs/api/types";
import { generateResult } from "../../../../../../global components/ResultModal/ResultModal";
import { WarningIcon } from "../../../../../../global components/Icons/WarningIcon";
type InputType = {
  reason: string;
  checked: boolean;
};
type PropType = {
  handleModal: () => void;
  mutate: () => void;
  id: string;
  emptyKey: string;
};
function DisableApiKey({
  handleModal,
  id,
  mutate,

  emptyKey,
}: PropType) {
  const token = UseAuthToken();
  const { trigger: disableKey, isMutating } = useSWRMutation(
    `api/admin/api-keys/${id}/revoke/`,
    swrMutationFetcher
  );
  const {
    register,
    reset,
    formState: { errors },
    handleSubmit,
  } = useForm<InputType>();
  const onSubmit: SubmitHandler<InputType> = async (data) => {
    try {
      const fetcherArg: SwrMutationFetcherArgType = {
        token,
        requestOption: {
          method: "POST",
          body: JSON.stringify({ reason: data.reason }),
          headers: {
            "Content-Type": "application/json",
          },
        },
      };
      const result: SuccessDataType<any> = await disableKey(fetcherArg);
      reset();
      mutate();
      generateResult("success", result.message);
      handleModal();
    } catch (error) {
      const e = parseClientError(error);
      generateResult("error", e.message);
    }
  };
  return (
    <div className={s.wrapper}>
      <div className={s.header}>
        <h4 className={s.title}>Disable API Key</h4>
        <h6 className={s.subtitle}>
          You are about to disable the following API Key
        </h6>
      </div>{" "}
      <span className={s.apiKey}> {emptyKey}</span>
      <form onSubmit={handleSubmit(onSubmit)} className={s.form}>
        <div className={s.inputWrapper}>
          <h6 className={s.label}>Reason for Disabling key</h6>
          <input
            type="text"
            {...register("reason")}
            className={clsx(s.input, {
              [s.inputError]: errors.reason?.message,
            })}
          />

          {errors.reason?.message && (
            <p className={s.errorMessage}>{errors.reason?.message}</p>
          )}
        </div>

        <div className={s.warning}>
          <WarningIcon className={s.icon} />
          <div className={s.message}>
            <h6 className={s.label}>Warning: Irreversible Action</h6>
            <p className={s.text}>
              Revoking this key is permanent. It will immediately terminate all
              services and applications linked to it. This action cannot be
              undone.
            </p>
          </div>
        </div>
        <div className={s.agreement}>
          <input
            type="checkbox"
            {...register("checked", { required: "required" })}
            className={clsx(s.checkbox, {
              [s.inputError]: errors.checked?.message,
            })}
          />
          <p>I understand the consequences and I wish to continue.</p>
        </div>
        <div className={s.btnGroups}>
          <button onClick={handleModal} type="button" className={s.cancelBtn}>
            Cancel
          </button>
          <Button
            loading={isMutating}
            htmlType="submit"
            className={s.submitBtn}
          >
            Revoke API Key{" "}
          </Button>
        </div>
      </form>
    </div>
  );
}

export default DisableApiKey;
